/**
 * Haalt het claimtoken uit de URL-fragment (#t=...) van /claim/bevestigen en
 * verwijdert het direct uit de zichtbare URL — vóórdat React, GTM of Sentry
 * laden. Het token blijft uitsluitend in geheugen (nooit local/sessionStorage).
 * Fragmenten worden nooit naar servers of in Referer-headers verstuurd.
 */
import { isClaimToken } from './claimFlow';

export const CLAIM_CONFIRM_PATH = '/claim/bevestigen';

let captured: string | null = null;

export function captureClaimTokenFromUrl(loc: Pick<Location, 'pathname' | 'hash' | 'search'> = window.location,
  replace: (url: string) => void = (url) => window.history.replaceState(null, '', url)): void {
  if (loc.pathname !== CLAIM_CONFIRM_PATH) return;
  if (!loc.hash && !loc.search) return;
  const params = new URLSearchParams(loc.hash.replace(/^#/, ''));
  const t = params.get('t');
  captured = isClaimToken(t) ? t.toLowerCase() : null;
  replace(CLAIM_CONFIRM_PATH);
}

/** Token uit geheugen (alleen deze paginasessie; verdwijnt bij herladen). */
export function getClaimToken(): string | null {
  return captured;
}

/** Wist het token uit geheugen, bijv. na een definitieve uitkomst. */
export function clearClaimToken(): void {
  captured = null;
}
